const PlayerState = {
    cards: {},
    role: null,
    username: null,
    id: null,
}

export default PlayerState